export const CLUSTER_DASHBOARD_TOOLTIPS = {
  actionRequiresTerraform: 'To perform this action, please use Terraform',
} as const;
